import ModalController from 'webmodals/modal.controller'
import resolve from 'ioc/resolve'
import _ from 'underscore'
import ServiceBus from 'servicestack/service-bus'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'

class DesignRatioPickerController extends ModalController {
    constructor($uibModalInstance, options) {
        super($uibModalInstance)
        const $ctrl = this;
        $ctrl.title = options.title || 'Select the shape of your design...';
        $ctrl.subTitle = options.subTitle;
        $ctrl.width = options.width;
        $ctrl.height = options.height;
        
        $ctrl.query = new AutoQuery({
            url: 'QueryProductTemplateTags/Ratio.json',
            autoLoad: true,
            scrub(response){
                response.data.results.forEach(r => {
                    let splat = r.tagLabel.split(':');
                    r.width = parseFloat(splat[0]) * 3000;
                    r.height = parseFloat(splat[1]) * 3000;
                    r.value = r.width/r.height;
                });
            }
        });

        console.debug('DesignRatioPickerController', options);
    }


    selectCustom() {
        const $ctrl = this;
        $ctrl.close($ctrl);
    }

    select(ratio) {
        const $ctrl = this;
        $ctrl.close(ratio);
    }
}

export default DesignRatioPickerController;